export const UserPlan = Object.freeze({
  enterprise: 'Enterprise',
  light: 'Light',
  partner: 'Partner',
  pro: 'Pro',
  memberBenefits: 'Member-Benefits',
});

export const PlanType = Object.freeze({
  free: 'free',
  startup: 'startup',
  pro: 'pro',
  enterprise: 'enterprise',
});

export const ChargebeePlan = Object.freeze({
  smePro: 'SME-PRO-OCT22',
  smeStartup: 'SME-STARTUP-OCT22',
  smeEnterprise: 'SME-ENTERPRISE-OCT22',
});

export const FlexiPlan = Object.freeze({
  flexi10: 'FLEXI-10',
});

export const UserSubscription = Object.freeze({
  month: 'month',
  year: 'year',
});

export const PartnerReferral = Object.freeze({
  revenueShare: 'REVENUE_SHARE',
  discount: 'DISCOUNT',
});

const comparePlans = (planToCompare) => (plan) => {
  if (typeof plan !== 'string' || typeof planToCompare !== 'string') {
    return false;
  }

  return plan.toLowerCase().startsWith(planToCompare.toLowerCase());
};

export const isUserPlanMemberBenefits = comparePlans(UserPlan.memberBenefits);
export const isUserPlanEnterprise = comparePlans(UserPlan.enterprise);
export const isUserPlanLight = comparePlans(UserPlan.light);
export const isUserPlanPro = comparePlans(UserPlan.pro);
export const isUserPlanPartner = comparePlans(UserPlan.partner);
export const isPaidPlan = (plan) =>
  isUserPlanEnterprise(plan) || isUserPlanPro(plan) || isUserPlanPartner(plan);
